export const PETTY_PURPOSES = [
    'STATIONERY',
    'BEVERAGE_PURCHASE',
    'BEVERAGE_SALE',
    'HYGIENE_CLEANING',
    'UTILITY_BILLS',
    'MEALS',
    'REPAIR_EQUIPMENT',
    'TABLEWARE',
    'TRANSPORT_POSTAGE',
    'OTHER',
    'VENUE_DISCOUNT_CASHOUT',
    'HIGH_HAND_BONUS',
    'STATIONERY_CLEANING',
    'BEVERAGE_MEALS',
    'EQUIPMENT_REPAIR_MISC',
];
/** Only these expense purposes may be selected for a new operation. */
export const PETTY_CREATE_PURPOSES = [
    'STATIONERY_CLEANING',
    'UTILITY_BILLS',
    'BEVERAGE_MEALS',
    'EQUIPMENT_REPAIR_MISC',
    'VENUE_DISCOUNT_CASHOUT',
    'HIGH_HAND_BONUS',
    'OTHER',
];
//# sourceMappingURL=accounting.js.map